import { render, staticRenderFns } from "./ReportBugModal.vue?vue&type=template&id=7c0fb80d&"
import script from "./ReportBugModal.vue?vue&type=script&lang=js&"
export * from "./ReportBugModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports